import axios from "axios";
import CONFIG from "../config.json";
import { StatsResponse } from "../types/warehouse";
import { ResultEntry } from "../types/data";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const api = axios.create({
  baseURL: CONFIG.API,
  timeout: 7000
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      if (cookies.get("access_key")) {
        cookies.remove("access_key", { path: "/" });
      }
    }
    return Promise.reject(error);
  }
);

export const WarehouseService = {
  async fetchStats(accessKey: string): Promise<StatsResponse> {
    const response = await api.get("stats", {
      params: { accessKey }
    });
    return response.data;
  },

  async fetchPalletData(location: string, accessKey: string) {
    const response = await api.get("", {
      params: {
        location: location,
        accessKey: accessKey
      }
    });
    return response.data;
  },

  async savePalletData(location: string, results: ResultEntry[], accessKey: string) {
    return api.post("", {
      results: results,
      location: location,
      accessKey: accessKey,
      overwriteLocation: true
    });
  }
};

export const fetchPalleteLocations = async (eans: string[], accessKey: string) => {
  const { data } = await api.post("findPalleteLocations", {
    eans,
    accessKey
  });
  return data;
};
